import CircularProgressWithLabel from "./component";
export default CircularProgressWithLabel;
